import React, { useState } from 'react';
import { FaRegUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleChangePassword = () => {
    navigate("/passwordrest");
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header
      className="yc-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        backgroundColor: "#f4f4f4",
        borderBottom: "1px solid #ddd",
      }}
    >
      <div className="yc-brand" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span className="yc-logo">YESCAST</span>
        <span className="yc-version" style={{ fontSize: "14px", color: "#555" }}>+971 6 5264382</span>
      </div>
      <div
        className="yc-user-icon"
        onClick={toggleDropdown}
        style={{ position: "relative", cursor: "pointer", fontSize: "24px" }}
      >
        <FaRegUser />
        {dropdownOpen && (
          <div
            className="yc-dropdown"
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
            }}
          >
            <button
              onClick={() => handleChangePassword()}
              style={{
                display: "block",
                width: "100%",
                padding: "8px 16px",
                background: "none",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
                color: "#333",
              }}
            >
              Change Password
            </button>
          </div>
        )}
      </div>
    </header>
  );
}